const LocationIcon = () => (
  <svg
    width="87"
    height="103"
    viewBox="0 0 87 103"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.1257 91.4212C44.3945 91.9578 43.7129 92.4447 43.0901 92.8814C42.4257 92.4407 41.6887 91.9338 40.8896 91.3624C37.1215 88.6664 32.2346 84.7088 27.4218 79.7728C17.55 69.6479 9.25 56.7237 9.25 42.9375C9.25 24.0217 24.5842 8.6875 43.5 8.6875C62.4157 8.6875 77.75 24.0217 77.75 42.9375C77.75 56.5759 69.0842 69.463 58.8514 79.6952C53.8869 84.6603 48.8909 88.6607 45.1257 91.4212ZM86.3125 42.9375C86.3125 77.1875 43.5 102.875 43.5 102.875C41.3594 102.875 0.6875 77.1875 0.6875 42.9375C0.6875 19.2928 19.8553 0.125 43.5 0.125C67.1445 0.125 86.3125 19.2928 86.3125 42.9375ZM52.0625 42.9375C52.0625 47.6663 48.2288 51.5 43.5 51.5C38.7712 51.5 34.9375 47.6663 34.9375 42.9375C34.9375 38.2085 38.7712 34.375 43.5 34.375C48.2288 34.375 52.0625 38.2085 52.0625 42.9375ZM60.625 42.9375C60.625 52.3956 52.9581 60.0625 43.5 60.0625C34.0419 60.0625 26.375 52.3956 26.375 42.9375C26.375 33.4796 34.0419 25.8125 43.5 25.8125C52.9581 25.8125 60.625 33.4796 60.625 42.9375Z"
      fill="currentColor"
    />
  </svg>
)
export default LocationIcon
